import { render, staticRenderFns } from "./dashboardShop.vue?vue&type=template&id=548cb602&scoped=true&"
import script from "./dashboardShop.vue?vue&type=script&lang=js&"
export * from "./dashboardShop.vue?vue&type=script&lang=js&"
import style0 from "./dashboardShop.vue?vue&type=style&index=0&id=548cb602&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548cb602",
  null
  
)

export default component.exports